import { render } from "./Translation.vue?vue&type=template&id=4588872b&scoped=true&ts=true"
import script from "./Translation.vue?vue&type=script&lang=ts"
export * from "./Translation.vue?vue&type=script&lang=ts"

import "./Translation.vue?vue&type=style&index=0&id=4588872b&lang=scss&scoped=true"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4588872b"]])

export default __exports__